import { Col, Row } from 'antd'
import { DATE } from 'app/common/constants'
import { AppointmentProvider } from 'app/context/AppointmentContext'
import { ItemCategoryProvider } from 'app/context/ItemCategoryContext'
import { ItemProvider } from 'app/context/ItemContext'
import { PageAppointmentProvider } from 'app/context/PageAppointmentContext'
import { PatientProvider } from 'app/context/PatientContext'
import moment from 'moment'
import { useState } from 'react'
import SidebarRight from './SideBarRight'
import SidebarLeft from './SidebarLeft'
import './index.css'
import { RootWrapper } from './styles'

const Appointment = () => {
  const [view, setView] = useState('week')
  const [selectedDate, setSelectedDate] = useState(
    moment().format(DATE.YYYY_MM_DD),
  )

  const onSelect = value => {
    setSelectedDate(value.format(DATE.YYYY_MM_DD))
  }

  return (
    <PageAppointmentProvider>
      <AppointmentProvider>
        <PatientProvider>
          <ItemCategoryProvider>
            <ItemProvider>
              <RootWrapper className="create-appointment">
                
                <Row>
                  <Col span={6}>
                    <SidebarLeft
                      onSelect={onSelect}
                      selectedDate={selectedDate}
                    />
                  </Col>
                  <Col span={18}>
                    <SidebarRight
                      selectedDate={selectedDate}
                      view={view}
                      setView={setView}
                      setSelectedDate={setSelectedDate}
                    />
                  </Col>
                </Row>
              </RootWrapper>
            </ItemProvider>
          </ItemCategoryProvider>
        </PatientProvider>
      </AppointmentProvider>
    </PageAppointmentProvider>
  )
}

export default Appointment
